<template>
  <!--  -->
  <div class="index-conatiner">
    <bannerImg :bannerText="bannerText"></bannerImg>
    <div class="index-content"></div>
  </div>
</template>

<script>
import bannerImg from '../components/bannerImg.vue';

export default {
  name: 'courseList',
  components: {
    bannerImg
  },
  data() {
    return {
      bannerText: '课程列表',
      tabList: [
        {
          name: '课程列表',
          url: 'courseList'
        },
        {
          name: '在线考试',
          url: 'onlineExam'
        },
        {
          name: '远程教育',
          url: ''
        },
        {
          name: '柏瑞康书斋',
          url: ''
        },
        {
          name: '学校风采',
          url: ''
        },
        {
          name: '个人中心',
          url: ''
        }
      ]
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    goTab(item) {
      console.log(item);
      if (this.$router.history.current.name !== item.url) {
        this.$router.push({ name: item.url });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.index-conatiner {
  min-height: 600PX;
  margin-top: 122PX;
}

.index-content {
  width: 72%;
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue